import { z } from "zod";

export const ROLES_WITH_ACCESS_CONTROL = ["superadmin", "admin"];

export const SCOPE = {
  DISTRICT: "district",
  SCHOOL: "school",
};

export const QUERY_KEYS = {
  districtActive: ["app-access", "district", "active"],
  districtHistory: ["app-access", "district", "history"],
  schoolActive: ["app-access", "school", "active"],
  schoolHistory: ["app-access", "school", "history"],
};

export const AUDIT_ACTIONS = {
  TURNED_OFF: "turned_off",
  TURNED_ON: "turned_on",
  EDITED_DETAILS: "edited_details",
};

export const AUDIT_ACTION_LABELS = {
  [AUDIT_ACTIONS.TURNED_OFF]: "Turned App OFF",
  [AUDIT_ACTIONS.TURNED_ON]: "Turned App ON",
  [AUDIT_ACTIONS.EDITED_DETAILS]: "Edited Details",
};

export const ACTION_STYLES = {
  [AUDIT_ACTIONS.TURNED_OFF]: "text-red-700    bg-red-50",
  [AUDIT_ACTIONS.TURNED_ON]: "text-emerald-700 bg-emerald-50",
  [AUDIT_ACTIONS.EDITED_DETAILS]: "text-blue-700   bg-blue-50",
};

export const MODAL_MODES = {
  CREATE: "create",
  EDIT: "edit",
};

const dateField = (message) =>
  z
    .any()
    .refine((val) => val !== undefined && val !== null, { message })
    .pipe(z.coerce.date());

export const restrictionSchema = z
  .object({
    startDate: dateField(
      "Please select the date you want to turn the app OFF.",
    ),
    endDate: dateField(
      "Please select the date you want to turn the app back ON.",
    ),
    reason: z
      .string()
      .trim()
      .min(
        15,
        "Please provide a reason of at least 15 characters so staff understand why access is restricted.",
      )
      .max(500, "Reason is too long — please keep it under 500 characters."),
  })
  .refine(
    (data) =>
      !data.startDate || !data.endDate || data.endDate >= data.startDate,
    {
      message: "The end date cannot be before the start date.",
      path: ["endDate"],
    },
  );
